import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'cj-tags',
  templateUrl: './cj-tags.component.html',
  styleUrls: ['./cj-tags.component.scss'],
})
export class CJTagsComponent implements OnInit {
  @Input() key = '';
  @Input() options = [];
  @Input() type: 'multi' | 'select' = 'multi';
  @Input() tagClass = 'bg-teal-30 text-cyan-60';
  @Output() selected = new EventEmitter<any>();
  @ViewChild('datalist') datalist!: ElementRef<HTMLDataListElement>;
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;

  currentFocus = -1;
  filteredOptions: HTMLOptionElement[] = [];
  selectedTag: any[] = [];
  tempOptions = [];
  toRemoved = -1;

  constructor() {}

  ngOnInit(): void {
    if (!this.options.length) return;

    this.tempOptions = [...this.options];

    if (this.type !== 'multi') this.setDefault();
  }

  onInput(value: string) {
    this.toRemoved = -1;
    this.datalist.nativeElement.style.display = 'block';
    var text = value.toUpperCase();
    const options = this.datalist.nativeElement.options;
    let index = '';
    let searchResult = 0;

    for (let option of Object.keys(options)) {
      if (options[option].value.toUpperCase().indexOf(text) > -1) {
        options[option].style.display = 'block';
        searchResult++;
        if (index === '') {
          index = option;
        }
      } else {
        options[option].style.display = 'none';
      }
    }

    if (!searchResult) {
      this.datalist.nativeElement.style.display = 'none';
    } else {
      this.currentFocus = parseInt(index, 10);
      this.addActive(this.datalist.nativeElement.options);
    }
  }

  onKeydown(event: KeyboardEvent) {
    switch (event.code) {
      case 'ArrowDown':
        this.currentFocus++;
        this.addActive(this.datalist.nativeElement.options);
        break;
      case 'ArrowUp':
        this.currentFocus--;
        this.addActive(this.datalist.nativeElement.options);
        break;
      case 'Enter':
        event.preventDefault();
        if (this.currentFocus === -1) {
          this.datalist.nativeElement.style.display = 'block';
          this.onInput('');
        } else if (
          this.currentFocus > -1 &&
          this.datalist.nativeElement.options
        ) {
          this.onSelect(this.filteredOptions[this.currentFocus].dataset.index);
        }
        break;
      case 'Backspace':
        if (this.selectedTag.length && this.toRemoved === -1) {
          this.toRemoved = this.selectedTag.length - 1;
          this.datalist.nativeElement.style.display = 'none';
          this.currentFocus = -1;
        } else if (this.toRemoved > -1) {
          this.removeTag(this.toRemoved);
          this.toRemoved = -1;
        }
        break;
    }
  }

  addActive(x: HTMLCollectionOf<HTMLOptionElement>) {
    if (!x) return false;
    this.removeActive(x);
    this.filteredOptions = Array.from(x).filter(
      (s) => window.getComputedStyle(s).getPropertyValue('display') != 'none'
    );

    if (this.currentFocus >= this.filteredOptions.length) this.currentFocus = 0;
    if (this.currentFocus < 0)
      this.currentFocus = this.filteredOptions.length - 1;

    this.filteredOptions[this.currentFocus].classList.add('active');
  }

  removeActive(x) {
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove('active');
    }
  }

  onSelect(selected) {
    this.input.nativeElement.value = '';

    if (this.type !== 'multi') {
      this.selectedTag = [this.options[selected]];
      this.selected.emit(this.selectedTag);
      this.hide();
      return;
    }

    const selectedTag = this.options.splice(selected, 1);
    this.selectedTag = [...this.selectedTag, ...selectedTag];
    this.selected.emit(this.selectedTag);
  }

  removeTag(index) {
    if (this.type !== 'multi') {
      this.onSelect(0);
      return;
    }
    this.selectedTag.splice(index, 1);
    this.options = this.tempOptions.filter(
      (option) => !this.selectedTag.includes(option)
    );
    this.selected.emit(this.selectedTag);
  }

  hide() {
    this.datalist.nativeElement.style.display = 'none';
    this.currentFocus = -1;
    this.toRemoved = -1;
  }

  setDefault() {
    this.selectedTag = [this.tempOptions[0]];
  }
}
